module.exports = __webpack_public_path__ + "img/bmbf_logo_neu_skaliert_klein.1571f9f2.svg";